import { createContext } from 'react';

export default createContext({
	applyMultiValueList: null,
	isNavigating: false,
	setIsNavigating: null
});
